/**
 * Part of datavideo project.
 *
 * @copyright  Copyright (C) 2021 ${ORGANIZATION}.
 * @license    __LICENSE__
 */

import '@main';

const input = $('.j-search-category-input');
const wrapper = $('.j-search-sidebar');
const type = input.data('type');
const parentCatId = input.data('parent-id');
let timer = 0;

getCategories(type);

input.on('input', function () {
  let key = $(this).val();

  clearTimeout(timer);

  timer = setTimeout(function () {
    getCategories(type, key);
  }, 500);
});

function getCategories(type, q) {
  const router = u.route('get_categories', { task: 'getCategories', q, type, parent_id: parentCatId });

  u.$http.get(router)
    .then(function (response) {
      wrapper.html(response.data.data.html);
    })
    .catch(function (e) {
      console.error(e);
    });
}
